import style from "./style.scss";

import { mergeClasses } from "../helpers";

const ButtonGroup = ({
  title,
  class: className = null,
  children,
  ...props
}) => {
  const mergedClass = mergeClasses([style.buttonOutline, className]);

  return (
    <div class={mergedClass} {...props}>
      <h5>{title}</h5>
      {children}
    </div>
  );
};

export default ButtonGroup;
